import lodash from 'lodash';

export default (value, token) => {
    let raw = '';
    let nice = '';
    let clonedValue = null;
    let wildcardToken = null;

    if (token[0] === '!') {
        // eslint-disable-next-line prefer-destructuring
        wildcardToken = token[1];
    }

    switch (typeof value) {
    case 'string':
        clonedValue = lodash.cloneDeep(value);
        break;
    case 'number':
        clonedValue = lodash.cloneDeep(value).toString();
        break;
    default:
        return {
            raw: '',
            nice: '',
        };
    }

    /* eslint-disable no-useless-escape */
    const tokens = {
        '#': { pattern: /\d/ },
        X: { pattern: /[0-9a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/ },
        S: { pattern: /[a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/ },
        A: { pattern: /[a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/, transform: (v) => v.toLocaleUpperCase() },
        a: { pattern: /[a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/, transform: (v) => v.toLocaleLowerCase() },
        G: { pattern: /[0-9a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/, transform: (v) => v.toLocaleUpperCase() },
        F: { pattern: /[0-9a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
        V: { pattern: /[0-9a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ\-\.]/, transform: (v) => v.toLocaleUpperCase() },
        g: { pattern: /[0-9a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/, transform: (v) => v.toLocaleLowerCase() },
        f: { pattern: /[0-9a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
    };
    /* eslint-enable no-useless-escape */

    (function compare(valueIterator, tokenIterator) {
        let clonedValueIterator = valueIterator;
        let clonedTokenIterator = tokenIterator;
        const currentToken = wildcardToken || token[clonedTokenIterator];
        if (tokens[currentToken] || wildcardToken) {
            if (clonedValue[clonedValueIterator]) {
                if (clonedValue[clonedValueIterator].match(tokens[currentToken].pattern)) {
                    if (tokens[currentToken].transform) {
                        raw += tokens[currentToken].transform(clonedValue[clonedValueIterator]);
                        nice += tokens[currentToken].transform(clonedValue[clonedValueIterator]);
                    } else {
                        raw += clonedValue[clonedValueIterator];
                        nice += clonedValue[clonedValueIterator];
                    }
                    clonedTokenIterator += 1;
                }
                clonedValueIterator += 1;
                if (clonedValueIterator < clonedValue.length
                    && (
                        clonedTokenIterator < token.length
                        || wildcardToken !== null
                    )) {
                    compare(clonedValueIterator, clonedTokenIterator);
                }
            }
        } else {
            nice += currentToken;
            clonedTokenIterator += 1;
            if (clonedTokenIterator < token.length || wildcardToken !== null) {
                compare(clonedValueIterator, clonedTokenIterator);
            }
        }
    }(0, 0));

    return {
        raw,
        nice,
    };
};
